<template>
  <BContainer
    class="mt-3 mb-3 container-pages ad-user-panel"
    v-if="advertisementDisplay"
  >
    <BRow class="g-3">
      <BCol xl="6">
        <div class="h-100">
         <div class="ad-card-header">
  <div class="ad-card-title-wrap" v-if="advertisementDisplay?.lawyer !== 1">
    <div class="ad-card-eyebrow">Prodavac</div>
    <h3 class="ad-card-title mb-0">
      {{ advertisementDisplay?.customer_name }}
    </h3>
  </div>

  <div class="ad-card-title-wrap" v-else>
    <div class="ad-card-eyebrow">Tezga</div>
    <h3 class="ad-card-title mb-1">
      {{ advertisementDisplay?.lawyer_name }}
    </h3>

    <div class="owner-box">
      <span class="owner-box-label">Vlasnik</span>
      <span class="owner-box-name">{{ advertisementDisplay?.customer_name }}</span>
    </div>
  </div>
</div>

          <div class="ad-card-body">
            <div class="info-list">
              <div class="info-row">
                <div class="info-label">Mesto</div>
                <div class="info-value">{{ advertisementDisplay?.place_name }}</div>
              </div>

              <div class="info-row">
                <div class="info-label">Član od</div>
                <div class="info-value">
                  {{ formatCreateDate(advertisementDisplay?.customer_created_at) }}
                </div>
              </div>

              <div
                class="info-row phone-row"
                @click="displayMobile = !displayMobile"
              >
                <div class="info-label">Telefon</div>

                <div v-if="displayMobile" class="info-value phone-value">
                  <i class="esei icon-phone color-awesome-ads me-2"></i>
                  {{ advertisementDisplay?.phone }}
                </div>

                <div v-else class="info-value phone-placeholder">
                  <i class="esei icon-phone color-awesome-ads me-2"></i>
                  Klikni za broj telefona
                </div>
              </div>
            </div>

            <div class="ad-actions mt-4">
              <a
                v-if="$screen.showMobileAds"
                class="btn action-btn action-btn-primary w-100"
                :href="`tel:${'+' + advertisementDisplay?.place_code + formatMobile(advertisementDisplay?.phone)}`"
              >
                Pozovite
              </a>

              <NuxtLink
                v-if="advertisementDisplay?.lawyer !== 1"
                class="btn action-btn action-btn-muted w-100"
                :to="{
                  name: 'oglas-svi-oglasi-customer-id',
                  params: {
                    customer: $srbTolat.srbTolat(advertisementDisplay?.customer_name),
                    id: advertisementDisplay?.customer_id
                  }
                }"
              >
              <i class="esei icon-user-solid me-2"></i>
                Svi oglasi korisnika
              </NuxtLink>

              <NuxtLink
                v-else
                class="btn action-btn action-btn-muted w-100"
                :to="{
                  name: 'tezga-lawyername-page',
                  params: {
                    lawyername: advertisementDisplay?.name_slug,
                    page: 1
                  }
                }"
              >
               <i class="esei icon-store-solid me-2"></i>
                Svi oglasi tezge
              </NuxtLink>

              <NuxtLink
                v-if="!cms"
                class="btn action-btn action-btn-muted w-100"
                :to="{
                  name: 'korisnicki-profil-poruke-slanje-poruke-adid',
                  params: {
                    adid: advertisementDisplay?.id
                  }
                }"
              >
              <i class="esei icon-envelope-solid me-2"></i>
                Pošalji poruku
              </NuxtLink>

              <NuxtLink
                v-if="!cms"
                class="btn action-btn action-btn-muted w-100"
                :to="{
                  name: 'oglas-ocene-customername-customerid-customertype-customerrate-page',
                  params: {
                    customername: $srbTolat.srbTolat(advertisementDisplay?.customer_name),
                    customerid: advertisementDisplay?.customer_id,
                    customertype: 'prodavac-kupac',
                    customerrate: 'sve-ocene',
                    page: 1
                  }
                }"
              >
              <i class="esei icon-ranking-star-solid me-2"></i>
                Ocene korisnika
              </NuxtLink>
            </div>
          </div>
        </div>
      </BCol>

      <BCol xl="6">
        <div class="h-100">
          <div class="ad-card-header">
            <div class="ad-card-title-wrap">
              <div class="ad-card-eyebrow">Statistika oglasa</div>
              <h3 class="ad-card-title mb-0">Pregled informacija</h3>
            </div>
          </div>

          <div class="ad-card-body">
            <div class="stats-grid">
              <div class="stat-box">
                <div class="stat-label">Viđeno</div>
                <div class="stat-value">{{ advertisementDisplay?.views_count }}</div>
              </div>

              <div class="stat-box">
                <div class="stat-label">Prati</div>
                <div class="stat-value">{{ advertisementDisplay?.followers_count }}</div>
              </div>
            </div>

            <div class="info-list mt-3">
              <div class="info-row">
                <div class="info-label">Datum objave</div>
                <div class="info-value">
                  {{ formatCreateDate(advertisementDisplay?.published_at) }}
                </div>
              </div>

              <div class="info-row expires-row">
                <div>
                  <div class="info-label">Ističe za</div>
                  <div class="expires-value">
                    {{ adDayDiff(advertisementDisplay) }}
                    {{ adDayDiff(advertisementDisplay) == 1 ? 'dan' : 'dana' }}
                  </div>
                </div>

                <div class="expires-date">
                  {{ formatCreateDate(advertisementDisplay?.expires_at) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </BCol>
    </BRow>
  </BContainer>
</template>

<script setup>
const device = useDevice()
const dayjs = useDayjs()
const { $srbTolat } = useNuxtApp()

import {
  BContainer,
  BRow,
  BCol,
  BFormSelect,
  BAlert,
  BPagination
} from 'bootstrap-vue-next'

import { useCustomerLoginStore } from "~/stores/login/customer"

const useStoreCustomer = useCustomerLoginStore()

const allowedCustomerIds = [20, 22, 28, 30, 26, 25]

const canShowSomething = computed(() => {
  if (!useStoreCustomer?.loggedIn) return false
  return allowedCustomerIds.includes(useStoreCustomer?.customer?.id)
})

const props = defineProps({
  advertisement: {
    required: true,
    type: Object
  },
  cms: {
    type: Boolean,
    default: false
  }
})

const displayMobile = ref(false)
const advertisementDisplay = ref()

const formatMobile = (mobile) => {
  try {
    return mobile.substring(1)
  } catch (error) {
    return '0000'
  }
}

const adDayDiff = (advertisementDisplay) => {
  const PUBLISH_FMT = 'DD.MM.YYYY'
  const published = dayjs(new Date(), PUBLISH_FMT)
  const expires = dayjs(advertisementDisplay.expires_at, PUBLISH_FMT)
  const days = expires.startOf('day').diff(published.startOf('day'), 'day')
  return days
}

const formatCreateDate = (created) => {
  return dayjs(created).format('DD.MM.YYYY.')
}

watchEffect(() => {
  advertisementDisplay.value = props.advertisement
})
</script>

 